"use strict";

var _defineProperty = require("/Users/tapanshah/aenetworks/aetn.editorials.washington/node_modules/@babel/runtime/helpers/defineProperty");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _reactJss = require("react-jss");

var _default = (0, _reactJss.withStyles)(function (_ref) {
  var screens = _ref.screens,
      colors = _ref.colors,
      _ref$typography = _ref.typography,
      fontFamily = _ref$typography.fontFamily,
      fontSize = _ref$typography.fontSize,
      fontWeightLight = _ref$typography.fontWeightLight,
      fontWeightNormal = _ref$typography.fontWeightNormal,
      fontWeightSemiBold = _ref$typography.fontWeightSemiBold,
      fontWeightBold = _ref$typography.fontWeightBold;
  return {
    base: {
      margin: 0,
      padding: 0,
      fontFamily: fontFamily,
      fontSize: fontSize,
      color: 'inherit' // '-webkit-font-smoothing': 'antialiased',

    },
    typeMainHeading: _defineProperty({
      fontSize: 50,
      fontWeight: fontWeightNormal,
      lineHeight: '100%'
    }, screens.xsDown, {
      fontSize: 29
    }),
    typeSectionHeading: _defineProperty({
      fontSize: 20,
      fontWeight: fontWeightSemiBold,
      lineHeight: '100%'
    }, screens.xsDown, {
      fontSize: 18,
      fontWeight: fontWeightNormal
    }),
    typeSectionTitleLg: _defineProperty({
      fontSize: 42,
      fontWeight: fontWeightSemiBold,
      lineHeight: '100%'
    }, screens.xsDown, {
      fontSize: 29
    }),
    typeSectionTitleMd: _defineProperty({
      fontSize: 29,
      fontWeight: fontWeightSemiBold,
      lineHeight: '100%'
    }, screens.xsDown, {
      fontSize: 20
    }),
    typeSectionTitleSm: _defineProperty({
      fontSize: 20,
      fontWeight: fontWeightSemiBold,
      lineHeight: '140%'
    }, screens.xsDown, {
      fontSize: 18
    }),
    typeCallOutLg: _defineProperty({
      fontSize: 18,
      fontWeight: fontWeightSemiBold,
      lineHeight: '120%'
    }, screens.xsDown, {
      fontSize: 16,
      fontWeight: fontWeightNormal
    }),
    typeCallOutMd: _defineProperty({
      fontSize: 16,
      fontWeight: fontWeightSemiBold,
      lineHeight: '120%'
    }, screens.xsDown, {
      fontSize: 14,
      fontWeight: fontWeightNormal
    }),
    typeCallOutSm: _defineProperty({
      fontSize: 14,
      fontWeight: fontWeightSemiBold,
      lineHeight: '120%'
    }, screens.xsDown, {
      fontSize: 12,
      fontWeight: fontWeightNormal
    }),
    typeTextLg: _defineProperty({
      fontSize: 18,
      fontWeight: fontWeightNormal,
      lineHeight: '160%'
    }, screens.xsDown, {
      fontSize: 16
    }),
    typeText: _defineProperty({
      fontSize: 16,
      fontWeight: fontWeightNormal,
      lineHeight: '160%'
    }, screens.xsDown, {
      fontSize: 14
    }),
    typeTextMd: {
      fontSize: 14,
      fontWeight: fontWeightNormal,
      lineHeight: '160%'
    },
    typeTextSm: {
      fontSize: 12,
      fontWeight: fontWeightNormal,
      lineHeight: '160%'
    },
    alignInherit: {
      textAlign: 'inherit'
    },
    alignLeft: {
      textAlign: 'left'
    },
    alignCenter: {
      textAlign: 'center'
    },
    alignRight: {
      textAlign: 'right'
    },
    alignJustify: {
      textAlign: 'justify'
    },
    transformUppercase: {
      textTransform: 'uppercase'
    },
    transformLowercase: {
      textTransform: 'lowercase'
    },
    transformCapitalize: {
      textTransform: 'capitalize'
    },
    transformFullWidth: {
      textTransform: 'full-width'
    },
    weightLight: {
      fontWeight: fontWeightLight
    },
    weightNormal: {
      fontWeight: fontWeightNormal
    },
    weightSemibold: {
      fontWeight: fontWeightSemiBold
    },
    weightBold: {
      fontWeight: fontWeightBold
    },
    gutter0: {
      paddingLeft: 0,
      paddingRight: 0
    },
    gutter2: {
      paddingLeft: 2,
      paddingRight: 2
    },
    gutter4: {
      paddingLeft: 4,
      paddingRight: 4
    },
    gutter8: {
      paddingLeft: 8,
      paddingRight: 8
    },
    gutter16: {
      paddingLeft: 16,
      paddingRight: 16
    },
    gutter24: {
      paddingLeft: 24,
      paddingRight: 24
    },
    gutter32: {
      paddingLeft: 32,
      paddingRight: 32
    },
    colorInherit: {
      color: 'inherit'
    },
    colorBackground: {
      color: colors.contrast
    },
    colorCover: {
      color: colors.coverContrast
    },
    colorPrimary: {
      color: colors.primary
    },
    colorPrimaryContrast: {
      color: colors.primary
    },
    colorSecondary: {
      color: colors.secondary
    },
    colorSecondaryContrast: {
      color: colors.secondaryContrast
    },
    styleItalic: {
      fontStyle: 'italic'
    },
    styleHighlight: {
      position: 'relative',
      marginTop: 4,
      '&:after': {
        content: "\"\"",
        position: 'absolute',
        width: 24,
        height: 4,
        background: colors.primary,
        transform: 'translateX(-50%)',
        top: -8,
        left: '50%'
      }
    },
    styleFullWidth: {
      width: '100%'
    },
    noWrap: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },
    lineClamp: {
      display: '-webkit-box',
      '-webkit-box-orient': 'vertical',
      overflow: 'hidden'
    }
  };
});

exports["default"] = _default;